<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <h1 class="title">My Team</h1>
      <app-cells class="cells--start-vertical">
        <app-input
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by name"
          name="search"
          @input.native="onSearch"
        />
        <app-select
          v-model="roles"
          :options="role_options"
          :reduce="item => item.code"
          :closeOnSelect="false"
          class="select--300"
          placeholder="Roles"
          multiple
          @input="fetchItems"
        />
      </app-cells>
      <v-client-table
        :data="items"
        :columns="columns"
        :options="options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__full_name><div class="table-default__left">Name</div></template>
        <template #h__position><div class="table-default__left">Position</div></template>
        <template #h__groups><div class="table-default__left">Roles</div></template>
        <template #full_name="{ row }">
          <div class="table-default__left table-default__left--photo">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.crop.crop_url)" alt="Avatar">
            </div>
            <span>{{ row.full_name }}</span>
          </div>
        </template>
        <template #position="{ row }">
          <div class="table-default__left">
            {{ row.employee && row.employee.position ? row.employee.position.name : '—' }}
          </div>
        </template>
        <template #groups="{ row }">
          <div class="table-default__left">
            {{ row.groups.length ? row.groups.map(group => group.name).join(', ') : '—' }}
          </div>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { getClimbingTeam } from '@/http'

export default {
  name: 'ClimbingMyTeam',
  data() {
    return {
      is_loaded: false,
      table_preloader: false,
      search: '',
      roles: [],
      items: [],
      role_options: [
        { code: 'climbing_supervisor', name: 'Climbing (Supervisor)' },
        { code: 'climbing_manager', name: 'Climbing (Manager)' },
        { code: 'climbing_assistant', name: 'Climbing (Assistant)' },
      ],
      columns: ['full_name', 'position', 'groups'],
      options: {
        headings: {
          full_name: 'Name',
          position: 'Position',
          groups: 'Roles',
        },
        pagination: { show: false },
        sortable: [],
        perPage: 100,
        texts: {
          noResults: 'No Climbing team members found',
        },
        rowClassCallback: () => 'table-default__row',
        resizableColumns: false,
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = this.is_loaded
      getClimbingTeam({
        search: this.search,
        groups: this.roles,
      })
        .then(response => {
          this.items = response.data
          this.is_loaded = true
        })
        .finally(() => { this.table_preloader = false })
    },
    onSearch() {
      this.table_preloader = true
      this.searchItems(this)
    },
    searchItems: debounce(vm => {
      vm.fetchItems()
    }, 350),
    getUserAvatar(cropUrl) {
      if (cropUrl) return cropUrl
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  },
}
</script>
